module.exports = __webpack_public_path__ + "static/media/mypic.da515b77.jpg";